import type {
  NativeGameSaveOperation, NativeGameSaveCampaign, NativeGameSaveStorageReply, PlaycastMessage,
  PlaycastMessageProcessSaveGame, PlaycastMessageProcessLoadGame,
  PlaycastMessageProcessCheckGameSaveConfiguration, PlaycastMessageProcessGameSaveStorageReply,
} from '../types';
import { formatMessage } from './_util/formatMessage';
import type { GameSaveCampaignConfiguration } from '../types/api/gameSaveCampaignConfiguration';

export function saveGame(hostId: string, message: NativeGameSaveOperation): PlaycastMessage<PlaycastMessageProcessSaveGame> {
  return formatMessage(hostId, 'host', { target: 'process', action: 'saveGame', isReply: false, message }) as
    PlaycastMessage<PlaycastMessageProcessSaveGame>;
}
export function loadGame(hostId: string, message: NativeGameSaveOperation): PlaycastMessage<PlaycastMessageProcessLoadGame> {
  return formatMessage(hostId, 'host', { target: 'process', action: 'loadGame', isReply: false, message }) as
    PlaycastMessage<PlaycastMessageProcessLoadGame>;
}
export function checkGameSaveConfiguration(hostId: string, campaign: NativeGameSaveCampaign, requestId: string,
  configuration?: GameSaveCampaignConfiguration):
  PlaycastMessage<PlaycastMessageProcessCheckGameSaveConfiguration> {
  return formatMessage(hostId, 'host', {
    target: 'process', action: 'checkGameSaveConfiguration', isReply: false,
    message: configuration === undefined ? { campaign, requestId } : { campaign, requestId, configuration },
  }) as PlaycastMessage<PlaycastMessageProcessCheckGameSaveConfiguration>;
}

export function gameSaveStorageReply(hostId: string, message: NativeGameSaveStorageReply):
  PlaycastMessage<PlaycastMessageProcessGameSaveStorageReply> {
  return formatMessage(hostId, 'host', { target: 'process', action: 'gameSaveStorage', isReply: true, message }) as
    PlaycastMessage<PlaycastMessageProcessGameSaveStorageReply>;
}
